export interface CompareRow {
  label: string;
  a: string;
  b: string;
}

export interface CompareTopic {
  id: string;
  title: string;
  question: string;
  tag: string;
  subjects: { name: string; icon: string; desc: string }[];
  rows: CompareRow[];
  verdict: string;
}

export const compareList: CompareTopic[] = [
  {
    id: "bankaikai",
    title: "半开麦 vs 真开麦：舞台“翻车”的界定与风险",
    question: "演唱会现场，到底唱到几成才算“没假唱”？",
    tag: "假唱红黑",
    subjects: [
      { name: "真开麦", icon: "ri-mic-line", desc: "人声为主要声源，音准全暴露" },
      { name: "半开麦/垫音", icon: "ri-volume-up-line", desc: "混入录音垫底，听感稳但有风险" },
    ],
    rows: [
      { label: "声源构成", a: "人声现场实时采集", b: "人声叠加录音垫音" },
      { label: "听感稳定性", a: "受状态影响大", b: "音准稳定、不易破音" },
      { label: "被扒风险", a: "几乎无假唱风险", b: "口型走位对不上时易翻车" },
      { label: "商演场景", a: "实力派、粉丝信任度高", b: "大型拼盘、唱跳密集场合" },
      { label: "舆论观感", a: "失误也容易获得包容", b: "被拆穿后解释空间小" },
    ],
    verdict: "观众反感的不是“垫音”，而是把垫音说成真唱还要立“实力派”人设。开诚布公标清“有垫音”，反而能堵住大半争议。",
  },
  {
    id: "shengming-leixing",
    title: "诚恳道歉 vs 公关甩锅：声明诚意浓度测试",
    question: "同样翻车，为什么有人顺利“洗白”有人越洗越黑？",
    tag: "声明对照",
    subjects: [
      { name: "诚恳型声明", icon: "ri-hand-heart-line", desc: "认事实、担责任、有行动" },
      { name: "甩锅型声明", icon: "ri-cloud-off-line", desc: "模糊事实、归因外界、无后续" },
    ],
    rows: [
      { label: "事实陈述", a: "主动点明具体争议点", b: "用“网传”回避细节" },
      { label: "责任归属", a: "承认自身过失", b: "归因环境、媒体、谣言" },
      { label: "时效性", a: "实锤后 24h 内回应", b: "拖至通报后被动回应" },
      { label: "后续动作", a: "公布停演、自查等安排", b: "一句“将反省”再无下文" },
      { label: "舆论走向", a: "反转空间小、道歉被认可", b: "越描越黑、二次发酵" },
    ],
    verdict: "翻车不可怕，可怕的是把道歉写成公关稿。观众要的是看得见的态度和能兑现的行动，而不是一套漂亮的四段式话术。",
  },
  {
    id: "liuliang-shili",
    title: "流量艺人 vs 实力派：塌房后的不同剧本",
    question: "为什么有的人塌房即退圈，有的人却能“体面”复出？",
    tag: "塌房现场",
    subjects: [
      { name: "纯流量路线", icon: "ri-flashlight-line", desc: "靠人设与粉丝数据驱动" },
      { name: "作品实力路线", icon: "ri-medal-line", desc: "靠作品沉淀与专业口碑" },
    ],
    rows: [
      { label: "粉丝黏性来源", a: "人设与应援成就感", b: "作品与专业认可" },
      { label: "塌房后抗性", a: "人设崩=根基崩，易退圈", b: "有代表作托底，回旋空间大" },
      { label: "商业合作依赖", a: "高度依赖代言与曝光", b: "依赖排片与演出档期" },
      { label: "复出难度", a: "需重建信任，周期长", b: "靠口碑作品逐步回温" },
      { label: "典型案例走向", a: "退圈或转型幕后", b: "沉寂后携作品回归" },
    ],
    verdict: "作品是明星最硬的“安全气囊”。纯流量走人设路线，把信任全押在“完美”上，一旦裂缝就无处可退；有作品的艺人则永远有一条靠专业回血的退路。",
  },
  {
    id: "guanfang-minjian",
    title: "官方通报 vs 粉丝澄清：信源博弈手册",
    question: "同一件事，官方还没说话，粉丝先急着“辟谣”，谁更可信？",
    tag: "信源博弈",
    subjects: [
      { name: "官方/权威通报", icon: "ri-bank-card-line", desc: "程序性、可复核的事实认定" },
      { name: "粉丝/后援会澄清", icon: "ri-flag-2-line", desc: "情绪驱动、证据常不完整" },
    ],
    rows: [
      { label: "证据标准", a: "需程序与多方核验", b: "多靠截图与单方说辞" },
      { label: "发布时效", a: "较慢，讲究流程", b: "极快，抢在通报前带节奏" },
      { label: "可信度", a: "较高、可作依据", b: "立场先行，需交叉验证" },
      { label: "常见失误", a: "偶有信息滞后", b: "仓促澄清反而引发反噬" },
    ],
    verdict: "吃瓜的正确姿势不是“先信哪边”，而是把两份说辞的时间点、证据链摆在一起比对。官方通报不等于永远对，但粉丝澄清也不等于事实。",
  },
];